import { render, staticRenderFns } from "./Choisir.vue?vue&type=template&id=68303c47&scoped=true&"
import script from "./Choisir.vue?vue&type=script&lang=js&"
export * from "./Choisir.vue?vue&type=script&lang=js&"
import style0 from "./Choisir.vue?vue&type=style&index=0&id=68303c47&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68303c47",
  null
  
)

component.options.__file = "Choisir.vue"
export default component.exports